import { render } from "./CardProtocolo.vue?vue&type=template&id=bbcc3fa0"
import script from "./CardProtocolo.vue?vue&type=script&lang=js"
export * from "./CardProtocolo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__